import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const CREATE_GITHUB_APP_VERSION = gql(`
    mutation CREATE_GITHUB_APP_VERSION($appID: ID!, $owner: String!, $repo: String!) {
        appVersionCreateGitHub(appID: $appID, input: {owner:$owner, repo:$repo}) {
            ... on AppVersion {
                id
            }
            ... on GitHubRepositoryNotFound {
                owner
                repo
            }
        }
    }
`);

export function useCreateGithubAppVersion() {
  return useMutation(CREATE_GITHUB_APP_VERSION);
}
